import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../actions/SeminarRegisteredManagermentViewer';
import withAuth from '../../common/WithAuth';
import ListSeminarRegistered, { Header } from '../../pages/SeminarRegisteredManagermentViewer/ListSeminarRegistered';
import selector from '../../selectors/SeminarRegisteredManagermentViewer';
import { GetListSeminarPausedRequested, ClearListSeminarPaused } from '../../actions/SeminarManagementViewer';
import { getSettingCustomTimerctrlRequest, getSettingCustomTimerctrlClear } from '../../actions/AdminSettingCustom';

const mapStateToProps = (state) => {
    const listSeminarResult = selector.createSeminarRegisteredManagermentViewerResultsSelector()(state);
    return {
        locale: state.locale.lang.current,
        listSeminarRegistered: state.seminarRegisteredManagermentViewer.listSeminarRegistered.data,
        listSeminarResult,
        eventInfo: state.registration.registrationViewer.data,
        listSeminarPaused: state.seminarManagementViewer.listSeminarPaused.data,
        customText: state.adminSettingCustom.getCustomText.data?.content,
        customColorSeminar: state.registrationOrganizer.registrationOrganizer.data?.settings_colors_viewer,
        customTimerctrl : state.adminSettingCustom.getCustomTimerctrl.data,
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchListSeminarRegistered: (params) => {
        dispatch(Actions.GetListSeminarRegisteredRequested(params));
    },
    clearData: () => {
        dispatch(Actions.ClearListSeminarRegistered());
    },
    fetchListSeminarPaused: (params) => {
        dispatch(GetListSeminarPausedRequested(params));
    },
    resetListSeminarPaused: () => {
        dispatch(ClearListSeminarPaused());
    },
    getSettingCustomTimerctrl: (params) =>{
        dispatch(getSettingCustomTimerctrlRequest(params));
    },
    clearCustomTimerctrl: () =>{
        dispatch(getSettingCustomTimerctrlClear() );
    },

});

export const ListSeminarRegisteredHeader = connect(mapStateToProps, mapDispatchToProps)(Header);

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ListSeminarRegistered);
